/**
 * Admin
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import {  HttpHeaders, HttpParams,
          HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ActiveUsersByPlanDto } from '../model/activeUsersByPlanDto';
import { CancellationReason } from '../model/cancellationReason';
import { CohortLifetimeRevenue } from '../model/cohortLifetimeRevenue';
import { ProductRevenue } from '../model/productRevenue';
import { ProductRevenueArgument } from '../model/productRevenueArgument';
import { ReportUserDto } from '../model/reportUserDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


import { JtHttp, HttpResponse } from '../../JtHttp';

@Injectable()
export class ReportingService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: JtHttp, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param range 
     * @param xVersion 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiAdminReportingActiveUsersByPlanGet(range?: string, xVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<ActiveUsersByPlanDto>;
    public apiAdminReportingActiveUsersByPlanGet(range?: string, xVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ActiveUsersByPlanDto>>;
    public apiAdminReportingActiveUsersByPlanGet(range?: string, xVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ActiveUsersByPlanDto>>;
    public apiAdminReportingActiveUsersByPlanGet(range?: string, xVersion?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (range !== undefined && range !== null) {
            queryParameters = queryParameters.set('range', <any>range);
        }

        let headers = this.defaultHeaders;
        if (xVersion !== undefined && xVersion !== null) {
            headers = headers.set('X-Version', String(xVersion));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ActiveUsersByPlanDto>('get',`${this.basePath}/api/Admin/Reporting/ActiveUsersByPlan`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param dayRange 
     * @param xVersion 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiAdminReportingCancellationReasonsGet(dayRange?: number, xVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<CancellationReason>>;
    public apiAdminReportingCancellationReasonsGet(dayRange?: number, xVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<CancellationReason>>>;
    public apiAdminReportingCancellationReasonsGet(dayRange?: number, xVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<CancellationReason>>>;
    public apiAdminReportingCancellationReasonsGet(dayRange?: number, xVersion?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (dayRange !== undefined && dayRange !== null) {
            queryParameters = queryParameters.set('dayRange', <any>dayRange);
        }

        let headers = this.defaultHeaders;
        if (xVersion !== undefined && xVersion !== null) {
            headers = headers.set('X-Version', String(xVersion));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<CancellationReason>>('get',`${this.basePath}/api/Admin/Reporting/CancellationReasons`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param xVersion 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiAdminReportingCohortLifetimeRevenuesGet(xVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<CohortLifetimeRevenue>>;
    public apiAdminReportingCohortLifetimeRevenuesGet(xVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<CohortLifetimeRevenue>>>;
    public apiAdminReportingCohortLifetimeRevenuesGet(xVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<CohortLifetimeRevenue>>>;
    public apiAdminReportingCohortLifetimeRevenuesGet(xVersion?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;
        if (xVersion !== undefined && xVersion !== null) {
            headers = headers.set('X-Version', String(xVersion));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<CohortLifetimeRevenue>>('get',`${this.basePath}/api/Admin/Reporting/CohortLifetimeRevenues`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param monthYear 
     * @param xVersion 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiAdminReportingProductRevenuesByStatusGet(monthYear?: string, xVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ProductRevenue>>;
    public apiAdminReportingProductRevenuesByStatusGet(monthYear?: string, xVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ProductRevenue>>>;
    public apiAdminReportingProductRevenuesByStatusGet(monthYear?: string, xVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ProductRevenue>>>;
    public apiAdminReportingProductRevenuesByStatusGet(monthYear?: string, xVersion?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (monthYear !== undefined && monthYear !== null) {
            queryParameters = queryParameters.set('monthYear', <any>monthYear);
        }

        let headers = this.defaultHeaders;
        if (xVersion !== undefined && xVersion !== null) {
            headers = headers.set('X-Version', String(xVersion));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ProductRevenue>>('get',`${this.basePath}/api/Admin/Reporting/ProductRevenuesByStatus`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param xVersion 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiAdminReportingProductRevenuesGet(body?: ProductRevenueArgument, xVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ProductRevenue>>;
    public apiAdminReportingProductRevenuesGet(body?: ProductRevenueArgument, xVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ProductRevenue>>>;
    public apiAdminReportingProductRevenuesGet(body?: ProductRevenueArgument, xVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ProductRevenue>>>;
    public apiAdminReportingProductRevenuesGet(body?: ProductRevenueArgument, xVersion?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let headers = this.defaultHeaders;
        if (xVersion !== undefined && xVersion !== null) {
            headers = headers.set('X-Version', String(xVersion));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Array<ProductRevenue>>('get',`${this.basePath}/api/Admin/Reporting/ProductRevenues`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param xVersion 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiAdminReportingUserPaymentHistoryGet(xVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ReportUserDto>>;
    public apiAdminReportingUserPaymentHistoryGet(xVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ReportUserDto>>>;
    public apiAdminReportingUserPaymentHistoryGet(xVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ReportUserDto>>>;
    public apiAdminReportingUserPaymentHistoryGet(xVersion?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;
        if (xVersion !== undefined && xVersion !== null) {
            headers = headers.set('X-Version', String(xVersion));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ReportUserDto>>('get',`${this.basePath}/api/Admin/Reporting/UserPaymentHistory`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
